<div class="outer-container flex flex-col">
  <div class="w-full titleBar m-0">
    <h2 class="text-white pl-3">
      Archived Wells
    </h2>
  </div>
  <div class="settings-container self-center">
    <a style="display: flex;" [routerLink]="['/', 'lmo']" class="py-1">
      <i class="material-icons">arrow_back</i>
      Back to Wells
    </a>
    <div class="spinner" *ngIf="isLoading">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <div [class.hidden]="isLoading">
      <mat-table
        class="pb-1"
        #archiveTable
        (matSortChange)="sortClusterTable($event, 'archive')"
        [dataSource]="archiveDataSource"
        matSort
      >
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell *matCellDef="let row" saAutomatedSelector="well__name"
            ><a (click)="openWellForm(row.id)" class="pr-2"> {{ row | fracName }}</a></mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="prefill">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Prefill Date</mat-header-cell>
          <mat-cell *matCellDef="let row" saAutomatedSelector="well__prefill-date">{{
            row.prefillDate | date
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="frac">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Frac Date</mat-header-cell>
          <mat-cell *matCellDef="let row" saAutomatedSelector="well__frac-date">{{ row.fracDate | date }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="invoice">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell class="link-row" *matCellDef="let row">
            <button
              mat-stroked-button
              color="primary"
              [routerLink]="['/', 'invoicing', 'orders_list', 'waiting_for_ticket_approval']"
              [queryParams]="{ fracIds: row.id }"
            >
              Invoicing
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedArchivedColumns" class="tableRow"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedArchivedColumns"
          saAutomatedSelector="well__row"
          [automatedName]="row | fracName"
        ></mat-row>
      </mat-table>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
